export default [{
  path: '/consulta-configuravel',
  name: 'consulta-configuravel',
  component: () => import('@/shared/components/consulta-configuravel/ConsultaConfiguravelView.vue'),
  meta: {
    resource: 'consultaConfiguravel',
    action: 'auditar',
    pageTitle: 'Consulta configurável de empresas',
    breadcrumb: [],
  },
}]
